import { render, staticRenderFns } from "./logisticcompanycomments.vue?vue&type=template&id=32cd78cd&"
import script from "./logisticcompanycomments.vue?vue&type=script&lang=js&"
export * from "./logisticcompanycomments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VRating})
